import { GlobalsService } from './../globals.service';
import { Component, OnInit } from '@angular/core';
import { ConfigProvider } from '../config-provider';
import { MessageExchange, MessageType } from '../message-exchange';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorBoxComponent } from '../error-box/error-box.component';
import { AlmaOidcService } from '@almaobservatory/alma-oidc-client';
import { environment } from '../../environments/environment'; 

const NOT_YET = '-';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {
  private buildInfo: any;
  public version: string;

  constructor(
    public globals: GlobalsService,
    public configProvider: ConfigProvider,
    private almaOidcService: AlmaOidcService,
    private modalService: NgbModal,
    private mx: MessageExchange
  ) {
    this.version = NOT_YET;
  }

  ngOnInit() {
    console.log('>>> page-header.ngOnInit ');

    this.configProvider.fetchBuildInfo().subscribe((buildInfo) => {
      this.buildInfo = buildInfo;

      // Extract version string from Git build version, assuming
      // it is something like '2021.03-SNAPSHOT'
      this.version = this.buildInfo.buildVersion;
      const index = this.version.lastIndexOf('-');
      if (index !== -1) {
        this.version = this.version.substring(0, index);
      }
      console.log('>>> version: ' + this.version);
    });

    // Put up a modal error box when we receive an error message
    this.mx.getMessageExchange().subscribe((message) => {
      if (message.type === MessageType.HttpError) {
        this.openErrorBox(
          message.serverName,
          message.errorDescription,
          message.errorInfo
        );
      }
    });
  }

  openErrorBox(serverName: string, errorDescription: string, errorInfo: any) {
    const errorBoxRef = this.modalService.open(ErrorBoxComponent);
    errorBoxRef.componentInstance.serverName = serverName;
    errorBoxRef.componentInstance.errorDescription = errorDescription;
    errorBoxRef.componentInstance.errorInfo = errorInfo;
  }

  logout() {
    console.log('>>> logout');
    this.almaOidcService.logout();
  }
  
  public isActivatedTab(name : string) {
	return environment.userAccountEditorTabActivation.get(name);
  }
}
